import React, { useState, useEffect } from 'react';
import { examAPI, studentsAPI } from '../../services/api';
import DataTable from '../../components/common/DataTable';
import StatusBadge from '../../components/common/StatusBadge';
import Modal from '../../components/common/Modal';
import toast from 'react-hot-toast';
import { formatDate } from '../../utils/helpers';
import SubjectList from './SubjectList';
import ExaminationSetup from './ExaminationSetup';
import GenerateHallTickets from './GenerateHallTickets';
import MarksGradeEntry from './MarksGradeEntry';
import Results from './Results';
import ReportCards from './ReportCards';

const ExaminationManagement = () => {
  const [tab, setTab] = useState('subjects');
  const [exams, setExams] = useState([]);
  const [results, setResults] = useState([]);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    name: '',
    exam_type: 'unit_test',
    class_obj: '',
    start_date: '',
    end_date: '',
    status: 'scheduled',
    academic_year: ''
  });
  const [academicYears, setAcademicYears] = useState([]);
  useEffect(() => {
    studentsAPI.classes()
      .then(r => setClasses(r.data.results || r.data))
      .catch(() => { });

    studentsAPI.academicYears()
      .then(r => {
        const data = r.data.results || r.data;
        console.log("Academic Years:", data);
        setAcademicYears(data);
      })
      .catch(err => console.log("Academic Years Error:", err));

    loadExams();
    loadResults();
  }, []);

  console.log("academicYears state:", studentsAPI.academicYears);

  // useEffect(() => {
  //   studentsAPI.classes().then(r => setClasses(r.data.results || r.data)).catch(() => { });
  //   loadExams();
  //   loadResults();
  // }, []);

  const loadExams = () => {
    setLoading(true);
    examAPI.exams().then(r => setExams(r.data.results || r.data)).catch(() => { }).finally(() => setLoading(false));
  };

  const loadResults = () => {
    examAPI.results({ page_size: 20 }).then(r => setResults(r.data.results || r.data)).catch(() => { });
  };

  const handleSaveExam = async (e) => {
    e.preventDefault();
    try {
      await examAPI.createExam(form);
      toast.success('Exam scheduled!');
      setShowModal(false);
      loadExams();
    } catch { toast.error('Failed to schedule exam'); }
  };

  const examColumns = [
    { key: 'name', label: 'Exam Name', render: v => <strong>{v}</strong> },
    { key: 'exam_type', label: 'Type', render: v => <span className="badge bg-info text-dark">{v?.replace('_', ' ')}</span> },
    { key: 'class_name', label: 'Class' },
    { key: 'start_date', label: 'Start Date', render: v => formatDate(v) },
    { key: 'end_date', label: 'End Date', render: v => formatDate(v) },
    { key: 'status', label: 'Status', render: v => <StatusBadge status={v} /> },
  ];

  const resultColumns = [
    { key: 'student_name', label: 'Student', render: v => <strong>{v}</strong> },
    { key: 'subject_name', label: 'Subject' },
    { key: 'marks_obtained', label: 'Marks', render: v => <strong>{v}</strong> },
    { key: 'max_marks', label: 'Max' },
    { key: 'percentage', label: '%', render: v => <span style={{ color: v >= 60 ? '#10b981' : v >= 35 ? '#f59e0b' : '#ef4444', fontWeight: 700 }}>{Number(v).toFixed(1)}%</span> },
    { key: 'grade', label: 'Grade', render: v => v ? <span className="badge bg-primary">{v}</span> : '—' },
    { key: 'is_pass', label: 'Result', render: v => <span className={`badge ${v ? 'bg-success' : 'bg-danger'}`}>{v ? 'Pass' : 'Fail'}</span> },
  ];

  return (
    <div>
      <div className="page-header mb-0">
        {/* <div><h2>Examination & Results</h2><p>Manage exams, marks entry, and report cards</p></div> */}
        {tab === 'exams' && <></>}
      </div>

      <div className="d-flex gap-2 mb-4 flex-wrap">
        {[['subjects', '📅 Assign Subjects'],['exams', '📅 Exams'], ['schedules', '🕒 Exams Setup'], ['GenerateHallTickets', '📊 Generate Hall Tickets'], ['MarksGradeEntry', '📊 Marks & Grade Entry'], ['results', '📊 Results'], ['reportcard', '📄 Report Cards']].map(([k, l]) => (
          <button key={k} className={`btn ${tab === k ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab(k)}>{l}</button>
        ))}
      </div>

      {tab === 'subjects' && (
         <SubjectList/>
        // <div className="card">
        //   <div className="card-header"><span>📅 Subjects ({exams.length})</span></div>
        //   <div className='card-body'>
           
        //   </div>
        //   <DataTable columns={examColumns} data={exams} loading={loading} />
        // </div>
      )}
      {tab === 'exams' && (
        <div className="card">
          <div className="card-header"><span>📅 Examinations ({exams.length})</span> 
          <button className="btn-add" onClick={() => setShowModal(true)}>📅 Schedule Exam</button>
          </div>
          <DataTable columns={examColumns} data={exams} loading={loading} />
        </div>
      )}

      {tab === 'schedules' && (
        <ExaminationSetup/>
        // <div className="card"><div className="card-body">
        //   <div className="alert alert-info">📋 Select an exam to view or manage its schedule.</div>
        //   <div className="row g-2 mb-3">
        //     <div className="col-md-4">
        //       <select className="form-select">
        //         <option>Select Exam</option>
        //         {exams.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
        //       </select>
        //     </div>
        //   </div>
        //   <div className="empty-state"><div className="empty-icon">🕒</div><h5>No Schedules</h5><p>Select an exam to view subject-wise schedule.</p></div>
        // </div></div>
      )}
      {tab === 'GenerateHallTickets' && (
        <GenerateHallTickets/>
      )}

      {tab === 'MarksGradeEntry' && (
        <MarksGradeEntry/>
      )}

      {tab === 'results' && (
        <div>
          {/* <div className="card mb-3"><div className="card-body">
            <div className="row g-2">
              <div className="col-md-3"><select className="form-select"><option>Select Exam</option>{exams.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}</select></div>
              <div className="col-md-3"><select className="form-select"><option>Select Class</option>{classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
              <div className="col-md-2"><button className="btn btn-primary w-100">🔍 Load</button></div>
              <div className="col-md-2"><button className="btn btn-success w-100">📥 Export</button></div>
            </div>
          </div></div> */}
          {/* <div className="card">
            <div className="card-header"><span>📊 Results ({results.length})</span></div>
            <DataTable columns={resultColumns} data={results} loading={false} />
          </div> */}
          <Results/>
        </div>
      )}

      {tab === 'reportcard' && (
        <ReportCards/>
        // <div className="card"><div className="card-body">
        //   <div className="row g-2 mb-4">
        //     <div className="col-md-3"><select className="form-select"><option>Select Exam</option>{exams.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}</select></div>
        //     <div className="col-md-3"><input className="form-control" placeholder="Admission Number or Name" /></div>
        //     <div className="col-md-2"><button className="btn btn-primary w-100">🔍 Search</button></div>
        //   </div>
        //   <div className="empty-state"><div className="empty-icon">📄</div><h5>Report Card Generator</h5><p>Search for a student to generate their report card.</p></div>
        // </div></div>
      )}

      <Modal show={showModal} onClose={() => setShowModal(false)} title="Schedule Examination">
        <form onSubmit={handleSaveExam}>
          <div className="mb-3">
            <label className="form-label">
              Academic Year *
            </label>

            <select
              className="form-select"
              value={form.academic_year}
              onChange={(e) =>
                setForm({
                  ...form,
                  academic_year: e.target.value
                })
              }
              required
            >

              <option value="">
                Select Academic Year
              </option>

              {academicYears.map((year) => (
                <option key={year.id} value={year.id}>
                  {year.year}
                </option>
              ))}

            </select>
          </div>
          <div className="mb-3"><label className="form-label">Exam Name *</label><input className="form-control" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="mb-3"><label className="form-label">Exam Type *</label>
            <select className="form-select" value={form.exam_type} onChange={e => setForm({ ...form, exam_type: e.target.value })}>
              <option value="unit_test">Unit Test</option><option value="mid_term">Mid Term</option>
              <option value="final">Final Exam</option><option value="practical">Practical</option>
            </select>
          </div>
          <div className="mb-3"><label className="form-label">Class *</label>
            <select className="form-select" value={form.class_obj} onChange={e => setForm({ ...form, class_obj: e.target.value })} required>
              <option value="">Select Class</option>
              {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="row">
            <div className="col-6 mb-3"><label className="form-label">Start Date *</label><input type="date" className="form-control" value={form.start_date} onChange={e => setForm({ ...form, start_date: e.target.value })} required /></div>
            <div className="col-6 mb-3"><label className="form-label">End Date *</label><input type="date" className="form-control" value={form.end_date} onChange={e => setForm({ ...form, end_date: e.target.value })} required /></div>
          </div>
          <div className="d-flex gap-2 justify-content-end">
            <button type="button" className="btn btn-outline-secondary" onClick={() => setShowModal(false)}>Cancel</button>
            <button type="submit" className="btn btn-primary">📅 Schedule</button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default ExaminationManagement;
